<template>
    <!-- ODOO-4440/4646: окно иерархической легенды-расшифровки (группа → серии).
         Компонент монтируется всегда (позиция окна переживает закрытие), окно —
         по visible. Группы строит ВЛАДЕЛЕЦ (utils/chartLegend.buildLegendGroups):
         они нужны ему до открытия панели (v-if кнопки легенды).
         Стрелка-привязка edges_svg — чартоспецифика, остаётся у владельца:
         ему отдаётся panelEl() и события geometry-change. -->
    <Teleport :to="overlayPortal(portal)"><!-- IE 2026 09 23 / ODOO-… (замечание Игоря: панели-меню в Full screen) -->
    <div class="chart-legend-panel chart-legend-panel-popup" ref="legendPanel" :data-widget="WIDGET && WIDGET.id" :class="{ 'chart-legend-tabbed': drillTabs }"
        :style="panelStyle()" v-if="visible"><!-- data-widget: окно легенды нужного виджета (пробы / отладка) · IE 2026 09 29 / ODOO-343341 (заказ Игоря: вкладка расшифровки в окне легенды): chart-legend-tabbed — окно с вкладками -->
        <!-- IE 2026 09 23 / ODOO-341407: i18n -->
        <div class="chart-legend-head" @mousedown="dragStart" v-uiHelp="'chart.legend.window'">
            <!-- IE 2026 09 10 / ODOO-… (замечание Игоря): крестик слева, как кнопка закрытия виджета (красный кружок); mousedown.stop —
                 клик по нему не начинает перетаскивание (иначе окно уезжало, а клик не доходил) -->
            <i class="pi pi-times chart-legend-close" v-uiHelp="'chart.legend.close'" :title="t('Close')" @mousedown.stop @click.stop="$emit('close')"/>
            <span>{{ t('Legend') }}</span>
            <!-- ODOO-4440: легенда = расшифровка. Клик по точке чарта ставит дату — значения строк считаются на неё; × возвращает
                 «последние». IE 2026 09 13 / ODOO-5800 (замечание Игоря): дата и крестик разморозки — в заголовке колонки периода
                 (gridFormatItem), не в шапке окна: в шапке и в заголовке колонки дата дублировалась -->
            <!-- IE 2026 09 16 (замечание Игоря): тумблер «все серии» из шапки снят — трёхпозиционный чекбокс стоит в заголовке колонки
                 чекбоксов (gridFormatItem), как «выбрать все» у колонок селектора / use в гридах -->
            <!-- ODOO-4440 (12.08): петличка свернуть/развернуть все группы — по просьбе АН;
                 Ctrl/Cmd+клик по шеврону группы работает как прежде. dragStart кнопки
                 шапки (.chart-legend-tools) из перетаскивания уже исключает -->
            <span class="chart-legend-tools">
                <i class="pi pi-angle-double-down" v-if="hasGroupRows()"
                    :title="t('Expand all groups')" v-uiHelp="'chart.legend.expandAll'" @click.stop="expandAll(true)"/>
                <i class="pi pi-angle-double-up" v-if="hasGroupRows()"
                    :title="t('Collapse all groups')" v-uiHelp="'chart.legend.collapseAll'" @click.stop="expandAll(false)"/>
            </span>
        </div>
        <!-- IE 2026 09 29 / ODOO-343341 (заказ Игоря: вкладка расшифровки в окне легенды — «форму расшифровки показывай как отдельную вкладку в форме легенды; для
             построения табов используй нашу компоненту AttrTabPanel»): у графика с расшифровкой (drillTabs) — вкладки [Breakdown | Legend] компонентой AttrTabPanel
             (вкладки из props: attr виджета не нужен, виджет не трогается); Breakdown — блоки ChartDrillBlocks последнего кликнутого кусочка (без клика — строка-
             подсказка), Legend — прежнее тело окна. Без вкладок (пузырьки, карта, график без расшифровки) тело окна рисуется как было, без обёрток (ChartLegendPlain
             отдаёт только слот tab-legend): разметка тела одна на оба случая -->
        <component :is="drillTabs ? 'AttrTabPanel' : 'ChartLegendPlain'" v-bind="tabsBind()" @local-select="onTabSelect">
        <template #tab-breakdown>
            <!-- нажатие в расшифровке закрепляет окно на месте (свёртка блока меняет высоту — окно по умолчанию иначе сдвинулось бы из-под мыши) -->
            <div class="chart-legend-drill" ref="drillHost" :style="drillW() ? { width: drillW() + 'px' } : null" @mousedown.capture="pinPos" @mousedown.stop>
                <ChartDrillBlocks v-if="drill" :model="drill" />
                <div v-else class="chart-legend-drill-hint" v-uiHelp="'chart.line.legend.tabBreakdown'">{{ t('Click a point or a bar of the chart — what its value consists of by the dimensions of the data source appears here.') }}</div>
            </div>
        </template>
        <template #tab-legend>
        <!-- ODOO-4440: тело легенды — wijmo FlexGrid (дерево групп/серий),
             как просил АН: штатные строки и вид грида вместо HTML-списка -->
        <div ref="legendGridHost" class="chart-legend-grid"></div>
        <!-- IE 2026 09 16 (замечание Игоря): нижний блок — показатели узла под курсором / выбранного кликом (пузырьки) либо итоги по узлам,
             выделенным прямоугольником; как значения выбранного диапазона у графика -->
        <!-- IE 2026 09 16 (уточнение Игоря): блок всегда на месте (заделы под заголовок и значения), ширина = ширина таблицы легенды —
             при смене узла под курсором окно не дрожит; строки таблицей: имя слева, значение справа, лишнее — «…» с подсказкой -->
        <div class="chart-legend-footer" v-if="footer && (footer.size || footer.x || footer.y || (footer.rows && footer.rows.length))" v-uiHelp="{ key: 'chart.legend.footer', state: () => (hoverRow ? 'hover' : (selectedRow ? 'selected' : (rectSel.length ? 'rect' : 'empty'))) }" :style="gridW ? { width: gridW + 'px' } : null" @mousedown.stop>
            <div class="chart-legend-footer-title" v-if="footer.title" :title="footer.title"><span class="chart-legend-footer-name">{{ footer.title }}</span><span class="chart-legend-footer-sub" v-if="footer.sub"> · {{ footer.sub }}</span></div>
            <!-- сначала мера размера пузырька под своим заголовком, ниже за разделителем — остальные реквизиты узла -->
            <template v-if="footer.size">
                <!-- IE 2026 09 23 / ODOO-341407: i18n -->
                <div class="chart-legend-footer-head"><i class="chart-legend-footer-sizepi"></i>{{ t('Bubble size') }}</div>
                <div class="chart-legend-footer-row chart-legend-footer-size">
                    <span class="chart-legend-footer-label" :title="footer.size.hint || footer.size.title">{{ footer.size.title }}</span>
                    <span class="chart-legend-footer-cell"><span class="chart-legend-footer-value" :title="String(footer.size.value || '').replace(/<[^>]+>/g, '')" v-html="footer.size.value || '\u00a0'"></span></span>
                </div>
            </template>
            <!-- IE 2026 09 16 (замечание Игоря): значения по осям X и Y — такими же блоками, как «Bubble size» -->
            <template v-for="ax in ['x', 'y']" :key="ax">
                <template v-if="footer[ax]">
                    <div class="chart-legend-footer-head"><i class="chart-legend-footer-axispi" :class="'chart-legend-footer-axispi-' + ax"></i>{{ ax === 'x' ? t('X axis') : t('Y axis') }}</div>
                    <div class="chart-legend-footer-row chart-legend-footer-axis" :class="'chart-legend-footer-' + ax">
                        <span class="chart-legend-footer-label" :title="footer[ax].hint || footer[ax].title">{{ footer[ax].title }}</span>
                        <span class="chart-legend-footer-cell"><span class="chart-legend-footer-value" :title="String(footer[ax].value || '').replace(/<[^>]+>/g, '')" v-html="footer[ax].value || '\u00a0'"></span></span>
                    </div>
                </template>
            </template>
            <div class="chart-legend-footer-sep" v-if="(footer.size || footer.x || footer.y) && footer.rows && footer.rows.length"></div>
            <div class="chart-legend-footer-row" v-for="(r, i) in footer.rows" :key="i">
                <span class="chart-legend-footer-label" :title="r.hint || r.title">{{ r.title }}</span>
                <span class="chart-legend-footer-cell"><i v-if="r.color" class="chart-legend-footer-dot" :style="{ background: r.color }"></i><span class="chart-legend-footer-value" :title="String(r.value || '').replace(/<[^>]+>/g, '')" v-html="r.value || '\u00a0'"></span></span>
            </div>
        </div>
        </template><!-- IE 2026 09 29 / ODOO-343341 (заказ Игоря: вкладка расшифровки в окне легенды): конец тела вкладки Legend -->
        </component>
    </div>
    </Teleport>
</template>

<script>
import { stableBoxApply, stableBoxReset } from '@/utils/stableBox'   // IE 2026 09 17 / ODOO-… (замечание Игоря): окно легенды не прыгает по размеру
import { useMainStore } from '@/stores/mainStore'
import { overlayPortal } from '@/utils/overlayRoot'   // IE 2026 09 23 / ODOO-… (замечание Игоря: панели-меню в Full screen): цель телепорта окна легенды
import uiHelp from '@/utils/uiHelp'   // U6 (заказ Игоря: объяснение элементов по Alt)
import altTooltip from '@/utils/altTooltip'   // U6: снять регистрацию подсказок у элементов, которые formatItem пересоздаёт
import * as wjGrid from '@mescius/wijmo.grid'
import ChartDrillBlocks from '@/components/widgets/ChartDrillBlocks.vue'   // IE 2026 09 29 / ODOO-343341 (заказ Игоря: вкладка расшифровки в окне легенды): блоки вкладки Breakdown
// IE 2026 09 29 / ODOO-343341 (заказ Игоря: вкладка расшифровки в окне легенды): окно без вкладок — тело окна (слот tab-legend) как есть, без обёрток и лишних узлов
const ChartLegendPlain = {
    name: 'ChartLegendPlain',
    inheritAttrs: false,
    emits: ['local-select'],
    render() { return this.$slots['tab-legend'] ? this.$slots['tab-legend']() : null },
}
// U6 (заказ Игоря: объяснение элементов по Alt): элементы, которые formatItem пересоздаёт на каждой перерисовке окна легенды (чекбоксы, имя,
// значок, счётчик, крестик разморозки, значок свёртки), регистрируются в общем инстансе подсказок, а wijmo Tooltip держит список
// зарегистрированных элементов и ищет по нему линейно (setTooltip). Содержимое ячейки wijmo сбрасывает ДО formatItem — прежние элементы
// к этому моменту уже вне ячейки, поэтому ячейка помнит, кого регистрировала (__u6kids), и снимает их с регистрации при следующей отрисовке
// (элементы ячеек wijmo переиспользует) — иначе список рос на каждой перерисовке (наведение на график перерисовывает легенду)
function uiHelp6_release(cell) {
    const kids = cell && cell.__u6kids
    if (!kids) return
    for (const el of kids) { try { altTooltip._bindFn(el, null) } catch (e) { /* элемент ушёл */ } }
    kids.length = 0
}
function uiHelp6_kid(cell, el, b) {
    uiHelp.bind(el, b)
    if (!cell.__u6kids) cell.__u6kids = []
    cell.__u6kids.push(el)
}
// объяснение ячейки значений — по колонке; у колонки имён — только подсвеченная строка (серия под курсором на графике), chart.legend.rowHighlight
const LEGEND_COL_HELP6 = { value: 'chart.legend.colPeriod', total: 'chart.legend.colTotal', hover: 'chart.legend.colPoint', dabs: 'chart.legend.colDelta', drel: 'chart.legend.colDeltaPct' }

export default {
    name: 'ChartLegendPanel',
    components: { ChartDrillBlocks, ChartLegendPlain },   // IE 2026 09 29 / ODOO-343341 (заказ Игоря: вкладка расшифровки в окне легенды)
    props: {
        WIDGET: { type: Object, required: true },      // портал (контейнер виджетов) + id
        flex: { type: Object, default: null },         // wijmo FlexChart: series для Z-порядка/цветов
        groups: { type: Array, default: () => [] },    // buildLegendGroups(...) владельца
        rows: { type: Array, default: () => [] },      // ряды данных (значения строк легенды)
        attrsByBinding: { type: Object, default: () => ({}) },
        pointIndex: { type: Number, default: null },   // режим расшифровки: индекс точки (у владельца)
        range: { type: Object, default: null },        // {i1, i2} — Σ-колонка (у владельца)
        // chart_down-зеркала — чартоспецифика: владелец передаёт свой unmirror
        unmirror: { type: Function, default: (binding, v) => v },
        visible: { type: Boolean, default: false },
        hoverBinding: { type: String, default: null },  // IE 2026 09 11 / ODOO-5800: серия под курсором на чарте — подсветка её строки
        // IE 2026 09 13 / ODOO-5800 (замечание Игоря): точка под курсором на чарте — без зафиксированной точки (pointIndex) значения и
        // дата заголовка колонки берутся по ней; null — курсор вне точек (значения «последние», заголовок Period)
        hoverIndex: { type: Number, default: null },
        // IE 2026 09 15 (замечание Игоря): колонки значений (Period / Total и колонки наведения) — у пузырькового графика легенда без
        // значений (классы со счётчиками), заголовок «Period» там был нелогичен
        valueColumn: { type: Boolean, default: true },
        // IE 2026 09 15 (заказ Игоря: селективные серии): состояние чекбокса селектора строки серии — (s) => {on, title} | null
        selState: { type: Function, default: null },
        // IE 2026 09 16 (замечание Игоря): нижний блок {title, sub, rows: [{title, value(HTML), color}]} — показатели узла / итоги выделения (пузырьки)
        footer: { type: Object, default: null },
        // IE 2026 09 29 / ODOO-343341 (заказ Игоря: вкладка расшифровки в окне легенды): вкладки [Breakdown | Legend] (график с расшифровкой кусочка; пузырьки и карта —
        // без вкладок), модель расшифровки последнего кликнутого кусочка (utils/chartDrillMixin.js, null — строка-подсказка) и выбранная вкладка (ведёт владелец)
        drillTabs: { type: Boolean, default: false },
        drill: { type: Object, default: null },
        tab: { type: String, default: 'breakdown' },
    },
    emits: ['series-toggle', 'group-toggle', 'series-settings', 'close',
            'point-reset', 'expand-changed', 'geometry-change', 'moved-z', 'series-select', 'series-hover', 'move-field',
            'tab-select'],   // IE 2026 09 29 / ODOO-343341 (заказ Игоря: вкладка расшифровки в окне легенды): выбор вкладки пользователем
    setup() {
        const store = useMainStore()
        return { store }
    },
    data: () => ({
        footerBox: { w: 0, h: 0 },   // IE 2026 09 17 / ODOO-… (замечание Игоря): нижний блок не сжимается обратно
        gridW: 0,   // IE 2026 09 16: ширина таблицы легенды — её же получает нижний блок (без дрожания ширины окна)
        grid: null,          // FlexGrid тела легенды (создаётся лениво)
        gridSigCache: null,      // сигнатура структуры строк — против мерцания групп
        pos: null,           // позиция окна после drag {x, y} (px от контейнера)
        drag: null,          // состояние перетаскивания
        portal: null,        // контейнер виджетов страницы (окно живёт в пейдже)
        showValues: true,    // значения в строках — видны по умолчанию (АН 08.08)
    }),
    watch: {
        // IE 2026 09 17 / ODOO-… (замечание Игоря): нижний блок легенды — размер не прыгает между узлами
        footer: { handler() { this.footerBox_fix() }, deep: true },
        groups() { this.$nextTick(() => this.rebuild()) },
        visible(v) { if (v) this.$nextTick(() => { this.rebuild(); this.$emit('geometry-change'); if (this.drillTabs) requestAnimationFrame(() => this.tabShown()) }); else this.gridHover(null) },   // IE 2026 09 12 / ODOO-…: скрыли — снять подсветку · IE 2026 09 29 / ODOO-343341 (заказ Игоря: вкладка расшифровки в окне легенды): окно с вкладками — показанную вкладку довести после кадра
        // выбор даты расшифровки включает значения (как legendSyncToSelection)
        pointIndex() { this.showValues = true; this.refreshHeaders(); this.grid?.invalidate() },
        range() { this.refreshHeaders(); this.grid?.invalidate() },
        hoverBinding() { this.grid?.invalidate() },   // IE 2026 09 11 / ODOO-5800
        // IE 2026 09 13 / ODOO-5800; IE 2026 09 15 (заказ Игоря): при зафиксированной точке наведение на другую точку заполняет колонки
        // «точка под курсором / отклонение от выбранной» — заголовок и значения обновляются на каждое наведение
        hoverIndex() { this.refreshHeaders(); this.grid?.invalidate() },
        // IE 2026 09 29 / ODOO-343341 (заказ Игоря: вкладка расшифровки в окне легенды): вкладки появились / убраны — тело легенды (хост грида) пересоздано, грид строится заново;
        // сменилась вкладка — показанную довести до кадра (грид, рисованный в скрытой вкладке, — refresh), окно и привязка — по новому размеру
        drillTabs() { this.$nextTick(() => { if (this.visible) { this.rebuild(); this.$emit('geometry-change') } }) },
        tab() { this.$nextTick(() => this.tabShown()) },
    },
    mounted() {
        if (this.visible) this.$nextTick(() => this.rebuild())
    },
    methods: {
        overlayPortal,   // IE 2026 09 23 / ODOO-… (замечание Игоря: панели-меню в Full screen): портал страницы, а в полноэкране виджета — сам виджет
        panelEl() { return this.$refs.legendPanel },
        invalidate() { this.grid?.invalidate() },
        // ---------------- IE 2026 09 29 / ODOO-343341 (заказ Игоря: вкладка расшифровки в окне легенды): вкладки [Breakdown | Legend] (AttrTabPanel, вкладки из props)
        // вкладки — один и тот же массив, пока подписи те же (полоса вкладок не перестраивается на каждом рендере; смена языка — новые подписи)
        legendTabs() {
            const b = this.t('Breakdown'), l = this.t('Legend'), c = this._legendTabs
            if (c && c[0].title === b && c[1].title === l) return c
            return (this._legendTabs = [
                { name: 'breakdown', html_id: 'chart-legend-tab-breakdown', title: b, help: { key: 'chart.line.legend.tabBreakdown', state: () => this.tab } },
                { name: 'legend', html_id: 'chart-legend-tab-legend', title: l, help: { key: 'chart.line.legend.tabLegend', state: () => this.tab } },
            ])
        },
        // пропсы панели вкладок (без вкладок — ничего: ChartLegendPlain лишних атрибутов не получает)
        tabsBind() {
            if (!this.drillTabs) return {}
            return { widget_id: this.WIDGET && this.WIDGET.id, localTabs: this.legendTabs(), localSelected: this.tab === 'legend' ? 'legend' : 'breakdown' }
        },
        // ширина окна с вкладками одна на обе вкладки (переключение не дёргает окно): ширина таблицы легенды, не уже 400 px (блоки расшифровки)
        tabW(w) { return this.drillTabs ? Math.max(w, 400) : w },
        drillW() { return this.drillTabs ? this.tabW(this.gridW || 0) : 0 },
        // выбор вкладки пользователем: окно остаётся на месте (полоса вкладок не уезжает из-под мыши — вкладки разной высоты), выбор — владельцу
        onTabSelect(name) {
            this.pinPos()
            this.$emit('tab-select', name)
        },
        // окно в положении по умолчанию — закрепить там, где оно сейчас (дальше его двигает только пользователь и правый край экрана)
        pinPos() {
            const p = this.$refs.legendPanel
            if (!this.pos && p) this.pos = { x: p.offsetLeft, y: p.offsetTop }
        },
        // вкладка показана: у Legend — грид, рисованный в скрытой вкладке, перестроить по месту; окно — по новому размеру
        tabShown() {
            if (!this.visible) return
            if (this.tab === 'legend' || !this.drillTabs) {
                this.rebuild()
                try { if (this.grid) this.grid.refresh(true) } catch (e) { /* грид ушёл */ }
            }
            this.relayout()
        },
        // содержимое окна изменило размер (ответ расшифровки, свёрнут / развёрнут блок, вкладка): окно не вылезает за правый край экрана, положение по умолчанию
        // (окно не двигали) — заново по новому размеру, привязка-стрелка — следом
        relayout() {
            if (!this.visible) return
            this.$nextTick(() => {
                const panel = this.$refs.legendPanel, r = panel ? panel.getBoundingClientRect() : null
                if (r && r.right > window.innerWidth - 8) {
                    const pos = this.pos || this.defaultPos()
                    this.pos = { x: Math.max(0, pos.x - (r.right - (window.innerWidth - 8))), y: pos.y }
                } else if (!this.pos) { this._defPos = null; this.$forceUpdate() }
                this.$nextTick(() => this.$emit('geometry-change'))
            })
        },
        // ---------------- окно: позиция/перетаскивание (в пределах пейджа)
        panelStyle() {
            this.ensurePortal()
            // IE 2026 09 12 / ODOO-…: положение по умолчанию считается один раз на построение окна (rebuild / refreshHeaders), а не на каждый
            // рендер — иначе окно прыгало на 8 px при наведении на строку (перерендер по пропсу hoverBinding, а размер окна
            // к тому моменту уже другой)
            const pos = this.pos || this._defPos || (this._defPos = this.defaultPos())
            const x = Math.max(0, pos.x), y = Math.max(0, pos.y)
            return { position: 'absolute', left: x + 'px', top: y + 'px', right: 'auto', bottom: 'auto', transform: 'none', zIndex: 1000 }
        },
        ensurePortal() {
            if (!this.portal) {
                this.portal = document.getElementById('WIDGET' + this.WIDGET.id)?.parentElement || null
            }
            return this.portal
        },
        // viewport → координаты containing block окна (left/top absolute считаются от ближайшего
        // positioned-предка портала, а не от самого портала: .main-area — static, окно ложится от body).
        // IE 2026 09 10 / ODOO-… (замечание Игоря): пересчёт через rect портала (top 42px) сдвигал окно вверх на 42px при каждом
        // mousedown/move — «прыгает выше и выше», крестик не срабатывал
        containingBlock() {
            let el = this.ensurePortal()
            while (el && el !== document.body && el !== document.documentElement) {
                const cs = getComputedStyle(el)
                if (cs.position !== 'static' || cs.transform !== 'none' || cs.filter !== 'none' || cs.perspective !== 'none') return el
                el = el.parentElement
            }
            return null   // initial containing block — документ
        },
        toPortal(x, y) {
            const el = this.containingBlock()
            if (!el) return { x: x + window.scrollX, y: y + window.scrollY }
            const r = el.getBoundingClientRect()
            return { x: x - r.left - el.clientLeft + el.scrollLeft, y: y - r.top - el.clientTop + el.scrollTop }
        },
        defaultPos() {
            // IE 2026 09 12 / ODOO-… (замечание Игоря): окно по умолчанию — СНАРУЖИ графика, прижато к рамке виджета: над графиком у правого
            // верхнего угла (низ окна к верхней границе), нет места сверху — справа от графика у верхнего края; нет места
            // и там — внутри у правого верхнего угла (как раньше). Размер окна — по отрисованному, до отрисовки — оценка
            // (rebuild после построения таблицы перерисовывает позицию по реальному размеру)
            const wEl = document.getElementById('WIDGET' + (this.WIDGET?.id ?? ''))
            const r = (wEl || this.flex?.hostElement)?.getBoundingClientRect()
            if (!r || !r.width) return this.toPortal(Math.max(0, window.innerWidth - 420), 90)
            const pr = this.$refs.legendPanel?.getBoundingClientRect()
            const w = (pr && pr.width > 50) ? pr.width : (this.range ? 540 : 420)
            const h = (pr && pr.height > 30) ? pr.height : 300
            const portal = this.ensurePortal()?.getBoundingClientRect()
            const minTop = Math.max(0, portal ? portal.top : 0), gap = 4
            if (r.top - gap - h >= minTop) return this.toPortal(Math.max(0, r.right - w), r.top - gap - h)
            if (r.right + gap + w <= window.innerWidth) return this.toPortal(r.right + gap, Math.max(minTop, r.top))
            return this.toPortal(Math.max(0, r.right - w - 10), Math.max(minTop, r.top + 8))
        },
        dragStart(e) {
            if (e.button !== 0) return
            if (e.target?.closest?.('.chart-legend-close, .chart-legend-tools')) return   // IE 2026 09 10 / ODOO-… (замечание Игоря): кнопки шапки
            const panel = this.$refs.legendPanel
            if (!panel) return
            const p = panel.getBoundingClientRect()
            // IE 2026 09 10 / ODOO-… (замечание Игоря): сдвиг viewport → система left/top берётся с самого окна (offsetLeft/Top против rect):
            // точен при любом containing block и не зависит от портала
            const ox = panel.offsetLeft - p.left, oy = panel.offsetTop - p.top
            this.pos = { x: panel.offsetLeft, y: panel.offsetTop }
            this.drag = { dx: e.clientX - p.left, dy: e.clientY - p.top }
            const move = (ev) => {
                const vp = { x: Math.min(Math.max(0, ev.clientX - this.drag.dx), window.innerWidth - 60),
                             y: Math.min(Math.max(0, ev.clientY - this.drag.dy), window.innerHeight - 30) }
                this.pos = { x: vp.x + ox, y: vp.y + oy }
                this.$emit('geometry-change')
            }
            const up = () => {
                document.removeEventListener('mousemove', move)
                document.removeEventListener('mouseup', up)
                this.drag = null
            }
            document.addEventListener('mousemove', move)
            document.addEventListener('mouseup', up)
            e.preventDefault()
        },
        // ---------------- заголовок: дата, «все серии»
        // IE 2026 09 13 / ODOO-5800: индекс строки значений — зафиксированная точка, без неё точка под курсором, иначе null («последние»)
        valueIndex() {
            return this.pointIndex != null ? this.pointIndex : (this.hoverIndex != null ? this.hoverIndex : null)
        },
        // дата строки для заголовка колонки: месяц (ГГГГ-ММ) у строк 1-го числа, полная дата у дневных
        dateText(i) {
            const row = (this.rows || [])[i]
            if (!row) return ''
            const d = row.date || row.date_parse
            const ds = (d instanceof Date) ? d.toISOString() : String(d ?? '')
            return /^\d{4}-\d{2}-01/.test(ds) ? ds.slice(0, 7) : ds.slice(0, 10)
        },
        allOn() {
            return this.groups.length > 0 && this.groups.every(g => g.checked)
        },
        allOff() { return this.groups.length > 0 && this.groups.every(g => !g.checked && !g.indeterminate) },   // IE 2026 09 16: ни одной видимой серии
        toggleAll() {
            const on = !this.allOn()
            for (const g of this.groups) this.$emit('group-toggle', g, on)
        },
        // группы-строки (с заголовком) есть — петличке есть что сворачивать;
        // у плоских списков (бабл-классы) иконки не показываем
        hasGroupRows() {
            return (this.groups || []).some(g => g.title && g.series.length)
        },
        expandAll(expand) {
            // ВСЕ группы с заголовком, не только collapsible: у группы с одной
            // серией collapsible=false (нет смысла в дефолтном сворачивании),
            // но петличкой её сворачивать можно — иначе на отборе в одну позицию
            // петличка «не работает»
            const map = {}
            for (const g of this.groups) {
                if (g.title) map[g.key] = expand
            }
            this.$emit('expand-changed', map)
        },
        // ---------------- тело: FlexGrid
        rebuild() {
            this._defPos = null   // {M}: новое построение — положение по умолчанию заново
            const host = this.$refs.legendGridHost
            // U6 (заказ Игоря: объяснение элементов по Alt): прежний грид окна (окно закрыто / пересоздано) — его пересоздаваемые элементы с регистрации подсказок
            if (this.grid && this.grid.hostElement !== host) { try { this.grid.hostElement.querySelectorAll('.wj-cell').forEach(uiHelp6_release) } catch (e) { /* грид ушёл */ } }
            if (!host) { this.grid = null; return }
            if (this.grid && this.grid.hostElement !== host) this.grid = null
            if (!this.grid) {
                this.grid = new wjGrid.FlexGrid(host, {
                    autoGenerateColumns: false,
                    headersVisibility: 'Column',
                    selectionMode: 'None',   // IE 2026 09 12 / ODOO-… (замечание Игоря): выделение строки/ячейки в легенде смысла не несёт
                    isReadOnly: true,
                    childItemsPath: 'children',
                    columns: [   // IE 2026 09 23 / ODOO-341407: i18n
                        { binding: 'name', width: '*', header: ' ' },
                        { binding: 'value', width: 100, align: 'right', header: this.t('Period'), visible: this.valueColumn },   // IE 2026 09 12 / ODOO-5800: UI strings English only
                        // Σ по выбранному диапазону периодов — виден при выборе >1 периода
                        { binding: 'total', width: 100, align: 'right', header: this.t('Total'), visible: false },   // IE 2026 09 12 / ODOO-5800
                        // IE 2026 09 15 (заказ Игоря): при выбранной (зафиксированной) точке — значение точки под курсором и её
                        // отклонение от выбранной: абсолютное и относительное
                        { binding: 'hover', width: 90, align: 'right', header: this.t('Point'), visible: false },
                        { binding: 'dabs', width: 84, align: 'right', header: 'Δ', visible: false },
                        { binding: 'drel', width: 70, align: 'right', header: 'Δ %', visible: false },
                    ],
                })
                this.grid.formatItem.addHandler((g, e) => this.gridFormatItem(g, e))
                // mousedown в capture: wijmo при selection перерисовывает ячейку до
                // click-фазы, и клик по кнопке/чекбоксу терялся
                host.addEventListener('mousedown', (e) => this.gridPress(e), true)
                host.addEventListener('click', (e) => this.gridClick(e))
                host.addEventListener('mouseup', (e) => this.gridRelease(e), true)   // IE 2026 09 12 / ODOO-…: клик по имени — см. gridRelease
                // IE 2026 09 12 / ODOO-… (заказ Игоря): строка серии под курсором → подсветка серии на чарте (как при наведении в самом чарте)
                host.addEventListener('mousemove', (e) => this.gridHover(e))
                host.addEventListener('mouseleave', () => this.gridHover(null))
                // Alt+↑/↓ — переместить выделенную серию (как перемещение строк в гридах)
                host.addEventListener('keydown', (e) => {
                    if (!e.altKey || (e.key !== 'ArrowUp' && e.key !== 'ArrowDown')) return
                    const grid = this.grid
                    // IE 2026 09 12 / ODOO-…: выделения нет — строка под курсором (gridHover)
                    const d = this._hoverKey ? [...(grid?.rows || [])].map(r => r.dataItem).find(x => x?.kind === 'series' && x.s?.binding === this._hoverKey) : null
                    if (d?.kind === 'series') {
                        e.preventDefault()
                        e.stopPropagation()
                        this.moveZ(d.s, e.key === 'ArrowUp' ? 1 : -1)
                    }
                }, true)
            }
            const rows = []
            for (const g of this.groups) {
                const children = g.series.map(sr => ({ kind: 'series', s: sr, name: sr.name, value: '' }))
                if (!g.title) rows.push(...children)   // одиночные меры — верхним уровнем
                else rows.push({ kind: 'group', g, key: g.key, name: g.title, value: '', children })
            }
            // сигнатура структуры: если состав/порядок строк не изменился (обычный
            // случай — тумблер видимости), НЕ переприсваиваем itemsSource: полная
            // пересборка строк давала мерцание сворачивания групп
            const sig = rows.map(r => r.kind === 'group'
                ? r.key + ':' + r.children.map(c => c.s.binding).join(',')
                : r.s.binding).join('|')
            if (this.grid.itemsSource && this.gridSigCache === sig) {
                const byKey = new Map()
                for (const r of rows) {
                    if (r.kind === 'group') { byKey.set('g:' + r.key, r); r.children.forEach(c => byKey.set('s:' + c.s.binding, c)) }
                    else byKey.set('s:' + r.s.binding, r)
                }
                for (const row of this.grid.rows) {
                    const d = row.dataItem
                    if (!d) continue
                    const fresh = byKey.get(d.kind === 'group' ? 'g:' + d.key : 's:' + d.s.binding)
                    if (fresh) { d.g = fresh.g; d.s = fresh.s }
                    // раскрытие применяем и на быстром пути: без этого петличка и
                    // Ctrl+клик по шеврону («все группы») меняли только модель, а
                    // строки грида оставались как были. Присвоение того же значения
                    // wijmo игнорирует — мерцания (b36cbcdf7) это не возвращает.
                    if (d.kind === 'group' && row.hasChildren) {
                        row.isCollapsed = !d.g.expanded
                    }
                }
                this.refreshHeaders()
                this.grid.invalidate()
                return
            }
            this.gridSigCache = sig
            this.grid.itemsSource = rows
            for (const row of this.grid.rows) {
                const d = row.dataItem
                if (d?.kind === 'group' && row.hasChildren) {
                    row.isCollapsed = !d.g.expanded
                }
            }
            this.refreshHeaders()   // IE 2026 09 12 / ODOO-…: после строк — ширина по содержимому
        },
        gridFormatItem(grid, e) {
            // IE 2026 09 13 / ODOO-5800 (замечание Игоря): заголовок колонки периода — дата точки (зафиксированной или под курсором) и
            // крестик разморозки у зафиксированной; раньше дата стояла и здесь, и в шапке окна
            if (e.panel === grid.columnHeaders) {
                uiHelp6_release(e.cell)   // U6 (заказ Игоря: объяснение элементов по Alt): прежние элементы заголовка — с регистрации подсказок
                if (grid.columns[e.col]?.binding === 'name') {
                    uiHelp.unbind(e.cell)   // U6: ячейка переиспользуется — объяснения у неё нет, есть у чекбокса «все серии»
                    // IE 2026 09 16 (замечание Игоря): чекбокс «все серии» в заголовке колонки — пусто / частично / все, клик — показать
                    // либо скрыть все (как чекбокс заголовка колонок селектора / use в гридах); прежний тумблер в шапке окна снят
                    const all = this.allOn(), none = this.allOff()
                    e.cell.innerHTML = ''
                    const cb = document.createElement('input')
                    cb.type = 'checkbox'
                    cb.className = 'chart-lg-check chart-lg-check-all'
                    cb.checked = all
                    cb.indeterminate = !all && !none
                    cb.title = all ? this.t('Hide all series') : this.t('Show all series')   // IE 2026 09 23 / ODOO-341407: i18n
                    e.cell.appendChild(cb)
                    uiHelp6_kid(e.cell, cb, { key: 'chart.legend.checkAll', state: () => (this.allOn() ? 'all' : (this.allOff() ? 'none' : 'some')) })   // U6
                    return
                }
                if (grid.columns[e.col]?.binding === 'hover') {   // IE 2026 09 15: дата точки под курсором
                    const hi = this.hoverCompareIndex()
                    e.cell.innerHTML = `<span class="chart-lg-hdr-date${hi != null ? ' chart-lg-hdr-hover' : ''}">${hi != null ? (this.dateText(hi) || this.t('Point')) : this.t('Point')}</span>`   // IE 2026 09 23 / ODOO-341407: i18n
                    uiHelp.bind(e.cell, { key: 'chart.legend.colPoint' })   // U6
                    return
                }
                if (grid.columns[e.col]?.binding !== 'value') {
                    // U6 (заказ Игоря: объяснение элементов по Alt): вспомогательные колонки сравнения — статичное объяснение
                    const b6 = grid.columns[e.col]?.binding
                    const k6 = b6 === 'total' ? 'chart.legend.colTotal' : b6 === 'dabs' ? 'chart.legend.colDelta' : b6 === 'drel' ? 'chart.legend.colDeltaPct' : ''
                    if (k6) uiHelp.bind(e.cell, { key: k6 })
                    else uiHelp.unbind(e.cell)
                    return
                }
                const idx = this.valueIndex()
                const txt = idx != null ? (this.dateText(idx) || this.t('Period')) : this.t('Period')   // IE 2026 09 23 / ODOO-341407: i18n
                const frozen = this.pointIndex != null
                e.cell.innerHTML = `<span class="chart-lg-hdr-date${frozen ? ' chart-lg-hdr-frozen' : (idx != null ? ' chart-lg-hdr-hover' : '')}">${txt}</span>`
                    + (frozen ? `<i class="pi pi-times chart-lg-hdr-reset" title="${this.t('Values at the clicked point — click to unfreeze')}"></i>` : '')
                uiHelp.bind(e.cell, { key: 'chart.legend.colPeriod', state: () => (this.pointIndex != null ? 'frozen' : (this.valueIndex() != null ? 'hover' : 'last')) })   // U6
                const reset6 = e.cell.querySelector('.chart-lg-hdr-reset'); if (reset6) uiHelp6_kid(e.cell, reset6, { key: 'chart.legend.unfreeze' })   // U6
                return
            }
            if (e.panel !== grid.cells) return
            const d = grid.rows[e.row]?.dataItem
            if (!d) return
            // IE 2026 09 11 / ODOO-5800: строка серии под курсором на чарте
            // IE 2026 09 14 / ODOO-5800: подсветка и по ПОЛЮ (мере): группа разреза меры и её серии (series_binding)
            const hb = this.hoverBinding
            const lit = !!hb && ((d.kind === 'series' && (d.s?.binding === hb || this.attrsByBinding?.[d.s?.binding]?.series_binding === hb))
                || (d.kind === 'group' && ((d.g?.key || d.key) === 'measure:' + hb)))
            e.cell.classList.toggle('chart-lg-hover', lit)
            // U6 (заказ Игоря: объяснение элементов по Alt): прежние элементы ячейки — с регистрации подсказок (ниже пересоздаются); объяснение самой
            // ячейки — смысл колонки (значения на дату / итог / точка / отклонения); у колонки имён — подсвеченная строка (серия под курсором)
            uiHelp6_release(e.cell)
            {
                const c6 = grid.columns[e.col]?.binding
                const k6 = c6 === 'name' ? (lit ? 'chart.legend.rowHighlight' : '') : (LEGEND_COL_HELP6[c6] || '')
                if (!k6) uiHelp.unbind(e.cell)
                else uiHelp.bind(e.cell, k6 === 'chart.legend.colPeriod' ? { key: k6, state: () => (this.pointIndex != null ? 'frozen' : (this.valueIndex() != null ? 'hover' : 'last')) } : { key: k6 })
            }
            const col = grid.columns[e.col].binding
            if (col === 'name') {
                const collapseBtn = e.cell.querySelector('.wj-elem-collapse')
                e.cell.innerHTML = ''
                if (collapseBtn) { e.cell.appendChild(collapseBtn); uiHelp6_kid(e.cell, collapseBtn, { key: 'chart.legend.groupChevron', state: () => (grid.rows[e.row]?.isCollapsed ? 'folded' : 'open') }) }   // U6
                const cb = document.createElement('input')
                cb.type = 'checkbox'
                cb.className = 'chart-lg-check'
                if (d.kind === 'group') {
                    cb.checked = d.g.checked
                    cb.indeterminate = d.g.indeterminate
                } else {
                    cb.checked = d.s.visible
                }
                e.cell.appendChild(cb)
                // U6 (заказ Игоря: объяснение элементов по Alt): чекбокс строки — своя мера / группа мер
                uiHelp6_kid(e.cell, cb, d.kind === 'group'
                    ? { key: 'chart.legend.groupCheck', state: () => (d.g.checked ? 'all' : (d.g.indeterminate ? 'some' : 'none')) }
                    : { key: 'chart.legend.seriesCheck', state: () => (d.s.visible ? 'on' : 'off') })
                // IE 2026 09 15 (заказ Игоря: селективные серии): второй чекбокс — значение разреза серии в чипсе стола
                const sel = (d.kind === 'series' && this.selState) ? this.selState(d.s) : null
                if (sel) {
                    const si = document.createElement('i')
                    si.className = 'pi chart-lg-sel ' + (sel.on ? 'pi-check-square' : 'pi-stop')
                    si.title = this.t('Click — add / remove «{name}» in the selector · Alt+click — only it', { name: sel.title || d.s.name || '' })   // IE 2026 09 23 / ODOO-341407: i18n
                    e.cell.appendChild(si)
                    uiHelp6_kid(e.cell, si, { key: 'chart.legend.selCheck', state: () => (sel.on ? 'on' : 'off') })   // U6
                }
                if (d.kind === 'series') {
                    const glyph = document.createElement('span')
                    glyph.className = 'chart-legend-glyph'
                    glyph.innerHTML = this.glyphHTML(d.s)
                    e.cell.appendChild(glyph)
                    uiHelp6_kid(e.cell, glyph, { key: 'chart.legend.glyph' })   // U6
                }
                const name = document.createElement('span')
                name.className = 'chart-lg-name' + (d.kind === 'series' && !d.s.visible ? ' chart-lg-off' : '')
                if (d.kind === 'group') name.classList.add('chart-lg-group')
                name.textContent = d.name || (d.kind === 'group' ? (d.g?.title || '') : (d.s?.name || ''))
                // IE 2026 09 12 / ODOO-…: клик — настройки серии (у группы-меры — Alt+клик), Alt+drag — порядок
                name.title = d.kind === 'series' ? this.t('Click — series settings · Alt+drag — reorder') : (String(d.key || '').startsWith('measure:') ? this.t('Alt+click — measure settings') : '')   // IE 2026 09 23 / ODOO-341407: i18n
                e.cell.appendChild(name)
                uiHelp6_kid(e.cell, name, { key: 'chart.legend.name' })   // U6
                if (d.kind === 'group') {
                    const cnt = document.createElement('span')
                    cnt.className = 'chart-legend-count'
                    cnt.textContent = d.g.series.length
                    e.cell.appendChild(cnt)
                    uiHelp6_kid(e.cell, cnt, { key: 'chart.legend.groupCount' })   // U6
                }
            } else if (col === 'value') {
                if (d.kind === 'series') {
                    // IE 2026 09 12 / ODOO-… (замечание Игоря): без иконок ▲▼⚙ — они (невидимые до наведения) сдвигали число влево,
                    // и колонка периода не совпадала по правому краю с колонкой итогов. Порядок — Alt+перетаскивание строки
                    // (Alt+↑/↓ с клавиатуры), настройки серии — клик по её имени
                    const off = !d.s.visible ? ' chart-lg-off' : ''
                    e.cell.innerHTML = `<span class="chart-lg-value${off}">${this.showValues ? this.valueHTML(d.s) : ''}</span>`
                } else {
                    e.cell.innerHTML = ''
                }
            } else if (col === 'total') {
                if (d.kind === 'series') {
                    const off = !d.s.visible ? ' chart-lg-off' : ''
                    e.cell.innerHTML = `<span class="chart-lg-value${off}">${this.totalHTML(d.s)}</span>`
                } else {
                    e.cell.innerHTML = ''
                }
            } else if (col === 'hover' || col === 'dabs' || col === 'drel') {   // IE 2026 09 15 (заказ Игоря): точка под курсором и отклонения
                e.cell.innerHTML = d.kind === 'series' ? this.compareHTML(d.s, col) : ''
            }
        },
        // IE 2026 09 15 (заказ Игоря): индекс точки под курсором для сравнения — только при зафиксированной точке и другой точке под курсором
        hoverCompareIndex() {
            return (this.pointIndex != null && this.hoverIndex != null && this.hoverIndex !== this.pointIndex) ? this.hoverIndex : null
        },
        hoverColumnsOn() { return this.valueColumn && this.pointIndex != null },
        // значение серии в точке под курсором / отклонение от выбранной точки: абсолютное (в единицах серии) и относительное (%)
        compareHTML(s, col) {
            const hi = this.hoverCompareIndex()
            if (hi == null) return ''
            const rows = this.rows || []
            const attr = this.attrsByBinding[s.binding]
            const off = !s.visible ? ' chart-lg-off' : ''
            const num = (i) => { const v = this.unmirror(s.binding, rows[i]?.[s.binding]); const n = +v; return (v === null || v === undefined || v === '' || !Number.isFinite(n)) ? null : n }
            const h = num(hi), f = num(this.pointIndex)
            const empty = '<span class="chart-legend-empty">—</span>'
            if (col === 'hover') return h == null ? empty : `<span class="chart-lg-value${off}">${this.durationHTML(h, attr) ?? this.store.formatCount(this.roundValue(h))}</span>`
            if (h == null || f == null) return empty
            const d = h - f
            const cls = d > 0 ? ' chart-lg-pos' : (d < 0 ? ' chart-lg-neg' : '')
            if (col === 'dabs') {
                const txt = this.durationHTML(Math.abs(d), attr) ?? this.store.formatCount(this.roundValue(Math.abs(d)))
                return `<span class="chart-lg-value${off}${cls}">${d > 0 ? '+' : (d < 0 ? '−' : '')}${txt}</span>`
            }
            if (!f) return empty
            const r = d / Math.abs(f) * 100
            const rt = Math.abs(r) >= 100 ? Math.round(Math.abs(r)) : Math.round(Math.abs(r) * 10) / 10
            return `<span class="chart-lg-value${off}${cls}">${r > 0 ? '+' : (r < 0 ? '−' : '')}${rt}%</span>`
        },
        // IE 2026 09 12 / ODOO-… (заказ Игоря): серия строки под курсором (null — курсор вне строк серий / вне окна); владелец подсвечивает
        // её на чарте той же подсветкой, что при наведении в чарте. Во время Alt+перетаскивания не трогаем
        gridHover(e) {
            const grid = this.grid
            let key = null
            if (e && grid && !this._legDrag) {
                const ht = grid.hitTest(e)
                const d = (ht && ht.panel === grid.cells) ? grid.rows[ht.row]?.dataItem : null
                if (d?.kind === 'series' && d.s?.binding) key = d.s.binding
            }
            if ((this._hoverKey || null) === key) return
            this._hoverKey = key
            this.$emit('series-hover', key)
        },
        gridPress(e) {
            // IE 2026 09 16 (замечание Игоря): чекбокс заголовка колонки — показать / скрыть все серии
            if (e.target.closest && e.target.closest('.chart-lg-check-all')) { e.preventDefault(); e.stopPropagation(); this.toggleAll(); this.$nextTick(() => this.grid?.invalidate()); return }
            const grid = this.grid
            if (!grid) return
            // IE 2026 09 13 / ODOO-5800: крестик разморозки в заголовке колонки периода (mousedown — ячейка заголовка перерисуется до click)
            if (e.target.closest('.chart-lg-hdr-reset')) {
                e.preventDefault(); e.stopPropagation()
                this.$emit('point-reset')
                return
            }
            const ht = grid.hitTest(e)
            if (!ht || ht.panel !== grid.cells) return
            const d = grid.rows[ht.row]?.dataItem
            if (!d) return
            // IE 2026 09 12 / ODOO-… (замечание Игоря): Alt + захват строки серии — перетаскивание в другой порядок (как Alt+drag строк грида)
            if (e.altKey && e.button === 0 && d.kind === 'series' && !e.target.closest('.chart-lg-check') && !e.target.closest('.chart-lg-sel')) {
                e.preventDefault(); e.stopPropagation()
                this.legDrag_start(e, ht.row, d)
                return
            }
            // IE 2026 09 12 / ODOO-…: клик по имени — запоминаем на mousedown: wijmo перерисовывает строку при выделении до click,
            // и click приходит на общего предка (ячейку), а не на span имени
            this._legNameDown = (e.button === 0 && e.target.closest('.chart-lg-name')) ? { row: ht.row, alt: !!e.altKey, t: performance.now() } : null
            if (e.target.closest('.chart-lg-check')) {
                e.preventDefault(); e.stopPropagation()
                if (d.kind === 'group') this.$emit('group-toggle', d.g)
                else this.$emit('series-toggle', d.s)
            }
            if (e.target.closest('.chart-lg-sel') && d.kind === 'series') {   // IE 2026 09 15: чекбокс селектора
                e.preventDefault(); e.stopPropagation()
                this.$emit('series-select', d.s, !!e.altKey)
            }
        },
        gridClick(e) {
            const grid = this.grid
            if (!grid) return
            // тумблер обработан на mousedown: нативный click по input ставил
            // галку обратно поверх перерисованной ячейки — «выключить не могу»
            if (e.target.closest('.chart-lg-check') || e.target.closest('.chart-lg-sel')) { e.preventDefault(); return }
            if (e.target.closest('.chart-lg-hdr-reset')) { e.preventDefault(); return }   // IE 2026 09 13 / ODOO-5800: обработан на mousedown
            if (this._legDragDone) { this._legDragDone = false; return }   // IE 2026 09 12 / ODOO-…: клик после перетаскивания — не настройки
            const ht = grid.hitTest(e)
            if (!ht || ht.panel !== grid.cells) return
            const d = grid.rows[ht.row]?.dataItem
            if (!d) return
            // IE 2026 09 12 / ODOO-…: настройки по клику на имени — в gridRelease (mouseup): после перерисовки строки на mousedown
            // элемент под курсором удалён, и браузер не генерирует click вовсе
            if (e.target.closest('.wj-elem-collapse')) {
                // wijmo сам свернёт/развернёт; Ctrl/Cmd — применить ко ВСЕМ группам
                const all = e.ctrlKey || e.metaKey
                setTimeout(() => {
                    if (all && d.kind === 'group') {
                        const expand = !grid.rows[ht.row]?.isCollapsed
                        this.expandAll(expand)
                        return
                    }
                    const map = {}
                    for (const row of grid.rows || []) {
                        const dd = row.dataItem
                        if (dd?.kind === 'group' && row.hasChildren) map[dd.key] = !row.isCollapsed
                    }
                    this.$emit('expand-changed', map)
                }, 0)
                return
            }
        },
        // IE 2026 09 12 / ODOO-… (замечание Игоря): Alt+перетаскивание строки серии — порядок серий (z-порядок чарта и строки легенды).
        // Цель — соседняя строка серии той же группы: линия-приёмник над/под ней, призрак с именем у курсора; Esc — отмена
        legDrag_start(e, row, d) {
            const grid = this.grid, host = this.$refs.legendGridHost
            if (!grid || !host) return
            if (getComputedStyle(host).position === 'static') host.style.position = 'relative'
            const line = document.createElement('div'); line.className = 'chart-lg-drop-line'; line.style.display = 'none'; host.appendChild(line)
            const ghost = document.createElement('div'); ghost.className = 'chart-lg-drag-ghost'; ghost.textContent = d.s?.name || d.name || ''; document.body.appendChild(ghost)
            const parentKey = grid.rows[row]?.dataItem?._legParent ?? this.legDrag_parentKey(row)
            const st = this._legDrag = { s: d.s, row, parentKey, line, ghost, target: null, moved: false, x0: e.clientX, y0: e.clientY }
            st.onMove = (ev) => this.legDrag_move(ev)
            st.onUp = (ev) => this.legDrag_end(ev, true)
            st.onKey = (ev) => { if (ev.key === 'Escape') this.legDrag_end(ev, false) }
            document.addEventListener('mousemove', st.onMove, true)
            document.addEventListener('mouseup', st.onUp, true)
            document.addEventListener('keydown', st.onKey, true)
            document.body.classList.add('chart-lg-dragging')
        },
        // ключ родителя строки (группа) — серии переставляются только внутри своей группы
        legDrag_parentKey(row) {
            const grid = this.grid
            const lvl = grid.rows[row]?.level ?? 0
            for (let r = row - 1; r >= 0; r--) { const rr = grid.rows[r]; if ((rr.level ?? 0) < lvl) return rr.dataItem?.key ?? r }
            return ''
        },
        legDrag_move(ev) {
            const st = this._legDrag; if (!st) return
            const grid = this.grid, host = this.$refs.legendGridHost
            if (!st.moved && Math.hypot(ev.clientX - st.x0, ev.clientY - st.y0) < 3) return
            st.moved = true
            st.ghost.style.left = (ev.clientX + 12) + 'px'; st.ghost.style.top = (ev.clientY + 8) + 'px'
            const hr = host.getBoundingClientRect()
            let target = null
            const ht = grid.hitTest(ev.clientX, ev.clientY)
            if (ht && ht.panel === grid.cells && ht.row >= 0) {
                const d = grid.rows[ht.row]?.dataItem
                if (d?.kind === 'series' && d.s?.binding !== st.s.binding && this.legDrag_parentKey(ht.row) === st.parentKey) {
                    const rc = grid.getCellBoundingRect(ht.row, 0)
                    const before = ev.clientY < rc.top + rc.height / 2
                    target = { row: ht.row, s: d.s, before }
                    st.line.style.display = 'block'
                    st.line.style.top = Math.round((before ? rc.top : rc.bottom) - hr.top - 1) + 'px'
                }
            }
            if (!target) st.line.style.display = 'none'
            st.target = target
            ev.preventDefault()
        },
        legDrag_end(ev, apply) {
            const st = this._legDrag; if (!st) return
            document.removeEventListener('mousemove', st.onMove, true)
            document.removeEventListener('mouseup', st.onUp, true)
            document.removeEventListener('keydown', st.onKey, true)
            document.body.classList.remove('chart-lg-dragging')
            st.line.remove(); st.ghost.remove()
            this._legDrag = null
            if (st.moved) this._legDragDone = true
            // IE 2026 09 12 / ODOO-…: порядок строк легенды = порядок полей виджета (viewList) — перенос делает владелец (AttrChart.onLegendMoveField):
            // поле переезжает в дереве конфига (запись помечается изменённой) и в живых attrs, серии перестраиваются
            if (apply && st.target) this.$emit('move-field', st.s, st.target.s, st.target.before)
            ev?.preventDefault?.()
        },
        // переставить серию s перед/после серии target в коллекции чарта (цвета палитры пиним, как в moveZ)
        moveTo(s, target, before) {
            const arr = this.flex?.series
            if (!arr) return
            const i = arr.findIndex(x => x.binding === s.binding)
            let j = arr.findIndex(x => x.binding === target.binding)
            if (i < 0 || j < 0 || i === j) return
            this.pinSeriesColors(arr)
            const sr = arr[i]
            arr.splice(i, 1)
            j = arr.findIndex(x => x.binding === target.binding)
            arr.splice(before ? j : j + 1, 0, sr)
            this.flex.refresh(true)
            this.$emit('moved-z', s, before ? -1 : 1)
        },
        pinSeriesColors(arr) {
            // палитровые цвета wijmo зависят от индекса серии — перед перестановкой
            // пиним каждый фактический цвет в style, чтобы цвет ехал ЗА серией
            for (const sr of arr) {
                if (sr.style) continue
                const el = sr.hostElement?.querySelector('polyline, path, rect, ellipse, circle')
                if (!el) continue
                const st = {}
                const stroke = el.getAttribute('stroke'), fill = el.getAttribute('fill')
                if (stroke && stroke !== 'none') st.stroke = stroke
                if (fill && fill !== 'none' && !String(fill).startsWith('url(')) st.fill = fill
                if (Object.keys(st).length) sr.style = st
            }
        },
        // IE 2026 09 12 / ODOO-… (замечание Игоря): клик по имени серии (с Alt или без) — настройки строки серии; у группы-меры — Alt+клик.
        // Пара mousedown (gridPress: _legNameDown) → mouseup на той же строке без перетаскивания
        gridRelease(e) {
            const nd = this._legNameDown; this._legNameDown = null
            if (!nd || e.button !== 0 || this._legDrag) return
            const grid = this.grid
            const ht = grid?.hitTest(e)
            if (!ht || ht.panel !== grid.cells || ht.row !== nd.row || performance.now() - nd.t > 800) return
            const d = grid.rows[ht.row]?.dataItem
            if (!d) return
            if (d.kind === 'series') { e.preventDefault(); this.$emit('series-settings', d.s); return }
            if (d.kind === 'group' && (nd.alt || e.altKey) && String(d.key || '').startsWith('measure:')) {
                e.preventDefault(); this.$emit('series-settings', { binding: String(d.key).slice('measure:'.length) })
            }
        },
        // ODOO-4440: Z-порядок из легенды — переставить серию в коллекции чарта
        // (wijmo рисует по порядку series, последняя — поверх)
        moveZ(s, dir) {
            const arr = this.flex?.series
            const i = arr ? arr.findIndex(x => x.binding === s.binding) : -1
            if (i < 0) return
            // сосед для свапа — ближайшая НЕслужебная серия: обмен со скрытой
            // (visibility 3, chartGroup) не меняет ни чарт, ни легенду —
            // выглядело как «стрелки не работают»
            let j = i + (dir > 0 ? 1 : -1)
            while (j >= 0 && j < arr.length && arr[j].visibility === 3) j += (dir > 0 ? 1 : -1)
            if (j < 0 || j >= arr.length || i === j) return
            // палитровые цвета wijmo зависят от индекса серии — перед перестановкой
            // пиним каждый фактический цвет в style, чтобы цвет ехал ЗА серией
            for (const sr of arr) {
                if (sr.style) continue
                const el = sr.hostElement?.querySelector('polyline, path, rect, ellipse, circle')
                if (!el) continue
                const st = {}
                const stroke = el.getAttribute('stroke'), fill = el.getAttribute('fill')
                if (stroke && stroke !== 'none') st.stroke = stroke
                if (fill && fill !== 'none' && !String(fill).startsWith('url(')) st.fill = fill
                if (Object.keys(st).length) sr.style = st
            }
            const sr = arr[i]
            arr.splice(i, 1)
            arr.splice(j, 0, sr)
            this.flex.refresh(true)
            // владелец пересобирает группы (buildLegendGroups) — watcher groups
            // перестроит грид; без этого строки оставались в старом порядке
            this.$emit('moved-z', s, dir)
        },
        // фактический цвет серии на чарте: из её SVG-группы (стили/палитра могут
        // расходиться с тем, что реально отрисовано — напр. однотонные DOS-линии)
        actualColor(s) {
            try {
                const sr = (this.flex?.series || []).find(x => x.binding === s.binding)
                const el = sr?.hostElement?.querySelector('polyline, path, rect, ellipse, circle')
                if (el) {
                    const stroke = el.getAttribute('stroke')
                    let fill = el.getAttribute('fill')
                    // столбики с градиентной заливкой url(#...): цвет = первый stop градиента
                    if (fill && String(fill).startsWith('url(')) {
                        const id = String(fill).match(/url\(["']?#([^"')]+)/)?.[1]
                        const stop = id && this.flex.hostElement?.querySelector(`[id="${id}"] stop`)
                        fill = stop ? (stop.getAttribute('stop-color') || null) : null
                    }
                    // у столбика главный цвет — заливка; stroke это обводка
                    const isBar = el.tagName === 'rect'
                    const c = isBar ? (fill || stroke) : ((stroke && stroke !== 'none') ? stroke : fill)
                    if (c && c !== 'none') return c
                }
            } catch (e) { /* нет SVG — цвет из настроек */ }
            return s.color
        },
        glyphHTML(s) {
            const c0 = this.actualColor(s) || '#999'
            // glyph:'dot' — маркер-кружок для «серий», не привязанных к сериям
            // wijmo (классы категорий бабла): у них нет chartType
            if (s.glyph === 'dot') {
                return `<svg width="15" height="15" viewBox="0 0 16 16"><circle cx="8" cy="8" r="5" style="fill:${c0}"/></svg>`
            }
            const rendered = this.flex?.series?.find(x => x.binding === s.binding)
            const ct = rendered ? rendered.chartType : null
            const c = c0
            // enum wijmo: 0 Column, 3 Line, 4 LineSymbols, 8 Area, 9 Spline,
            // 10 SplineSymbols, 11 SplineArea, 12 Scatter/…; свеча — сток-режим
            const t = (v) => `<svg width="15" height="15" viewBox="0 0 16 16">${v}</svg>`
            if (ct === 3 || ct === 4) return t(`<polyline points="1,13 6,6 10,9 15,2" style="fill:none;stroke:${c};stroke-width:2"/>`)
            if (ct === 9 || ct === 10) return t(`<path d="M1 12 C 5 2, 8 15, 15 4" style="fill:none;stroke:${c};stroke-width:2"/>`)
            if (ct === 8 || ct === 11) return t(`<path d="M1 14 L1 10 C5 4,9 12,15 6 L15 14 Z" style="fill:${c};opacity:.55;stroke:${c}"/>`)
            if (ct === 12) return t(`<g style="fill:${c}"><circle cx="3" cy="11" r="2"/><circle cx="8" cy="5" r="2"/><circle cx="13" cy="9" r="2"/></g>`)
            return t(`<g style="fill:${c}"><rect x="1.5" y="7" width="3.4" height="8"/><rect x="6.3" y="3" width="3.4" height="12"/><rect x="11.1" y="9" width="3.4" height="6"/></g>`)
        },
        valueHTML(s) {
            const rows = this.rows || []
            // режим расшифровки: значение на дату точки, выбранной кликом по чарту (IE 2026 09 13 / ODOO-5800: без клика — точки под курсором)
            const idx = this.valueIndex()
            if (idx != null) {
                const v = this.unmirror(s.binding, rows[idx]?.[s.binding])
                if (v === null || v === undefined || v === '') return '<span class="chart-legend-empty">—</span>'
                const attr = this.attrsByBinding[s.binding]
                return this.durationHTML(v, attr) ?? this.store.formatCount(this.roundValue(v)) // IE 2026 09 10 / ODOO-5800
            }
            // иначе «текущее» значение серии — последняя непустая точка ряда
            for (let i = rows.length - 1; i >= 0; i--) {
                const v = this.unmirror(s.binding, rows[i]?.[s.binding])
                if (v !== null && v !== undefined && v !== '') {
                    const attr = this.attrsByBinding[s.binding]
                    return this.durationHTML(v, attr) ?? this.store.formatCount(this.roundValue(v)) // IE 2026 09 10 / ODOO-5800
                }
            }
            return ''
        },
        roundValue(v) {
            const n = +v
            if (!Number.isFinite(n)) return v
            return Math.abs(n) < 100 ? Math.round(n * 100) / 100 : Math.round(n)
        },
        // итог по выбранному диапазону: потоковые меры — сумма, дни (DOS) — среднее
        totalHTML(sr) {
            const range = this.range
            if (!range) return ''
            const rows = this.rows || []
            let sum = 0, cnt = 0
            for (let i = range.i1; i <= range.i2; i++) {
                const v = +this.unmirror(sr.binding, rows[i]?.[sr.binding])
                if (Number.isFinite(v)) { sum += v; cnt++ }
            }
            if (!cnt) return '<span class="chart-legend-empty">—</span>'
            const attr = this.attrsByBinding[sr.binding]
            if (attr?.attr_type === 'AttrDays' || attr?.attr_type === 'AttrTime') {
                return this.durationHTML(this.roundValue(sum / cnt), attr) // IE 2026 09 10 / ODOO-5800: DOS в секундах — тоже среднее
            }
            return this.store.formatCount(this.roundValue(sum))
        },
        // IE 2026 09 10 / ODOO-5800 (заказ Игоря): длительность серии — AttrDays (дни) и AttrTime (секунды: DOS,
        // Offset) — своим форматтером (месяцы при format 'm'); null — не длительность
        durationHTML(v, attr) {
            if (attr?.attr_type === 'AttrDays') return this.store.formatDaysHTML(v, attr)
            if (attr?.attr_type === 'AttrTime') return this.store.formatTimeHTML(v, attr)
            return null
        },
        // IE 2026 09 12 / ODOO-… (замечание Игоря): ширина окна по содержимому — колонка имени по самому длинному имени (отступ уровня дерева,
        // шеврон группы, чекбокс, значок серии, счётчик группы; текст меряется полужирным — так рисуется строка под курсором),
        // колонки значений по 100 px, запас под вертикальную полосу прокрутки; не уже 240 и не шире 640 px (и 60% экрана по CSS)
        contentWidth() {
            const grid = this.grid, host = this.$refs.legendGridHost
            const cols = (this.valueColumn ? 1 : 0) + (this.range ? 1 : 0)   // IE 2026 09 15: без колонок значений у пузырькового графика
            const extra = this.hoverColumnsOn() ? 244 : 0   // IE 2026 09 15: колонки точки под курсором и отклонений
            if (!grid || !host) return this.tabW(240 + cols * 100 + extra)   // IE 2026 09 29 / ODOO-343341 (заказ Игоря: вкладка расшифровки в окне легенды): с вкладками — не уже блоков расшифровки
            const ctx = (this._measureCtx = this._measureCtx || document.createElement('canvas').getContext('2d'))
            const cs = getComputedStyle(host)
            ctx.font = `600 ${cs.fontSize || '12px'} ${cs.fontFamily || 'sans-serif'}`
            let nameW = 0
            for (const row of grid.rows) {
                const d = row.dataItem
                if (!d) continue
                const name = d.name || (d.kind === 'group' ? (d.g?.title || '') : (d.s?.name || ''))
                let w = 12 + 22 + (row.level || 0) * 14 + ctx.measureText(String(name)).width
                w += d.kind === 'series' ? 21 : 20 + 6 + ctx.measureText(String(d.g?.series?.length ?? '')).width
                if (w > nameW) nameW = w
            }
            return this.tabW(Math.max(240, Math.min(640 + extra, Math.ceil(nameW + cols * 100 + extra + 18))))   // IE 2026 09 29 / ODOO-343341 (заказ Игоря: вкладка расшифровки в окне легенды): с вкладками — не уже 400 px
        },
        // IE 2026 09 17 / ODOO-… (замечание Игоря): нижний блок легенды (узел под курсором / выбранный) не скачет
        // по высоте при переходе между узлами — держим достигнутый максимум, лишнее место остаётся пустым
        footerBox_fix() {
            this.$nextTick(() => {
                const el = this.$refs.legendPanel?.querySelector?.('.chart-legend-footer')
                if (el) stableBoxApply(el, this.footerBox, this.store.setting('fe.ux.legendStableSize', true) !== false)
            })
        },
        footerBox_reset() { stableBoxReset(this.footerBox, this.$refs.legendPanel?.querySelector?.('.chart-legend-footer')) },
        refreshHeaders() {
            const grid = this.grid
            if (!grid) return
            const range = this.range
            // имена серий не должны сжиматься: с колонкой «Итого» окно шире;
            // расширение у правого края экрана — со сдвигом окна влево
            const host = this.$refs.legendGridHost
            if (host) {
                host.style.width = this.contentWidth() + 'px'   // IE 2026 09 12 / ODOO-… (замечание Игоря): по содержимому, не 400/520
                this.gridW = this.contentWidth()   // IE 2026 09 16: нижний блок той же ширины
                this.$nextTick(() => {
                    const panel = this.$refs.legendPanel
                    const r = panel?.getBoundingClientRect()
                    if (r && r.right > window.innerWidth - 8) {
                        const dx = r.right - (window.innerWidth - 8)
                        const pos = this.pos || this.defaultPos()
                        this.pos = { x: Math.max(0, pos.x - dx), y: pos.y }
                        this.$emit('geometry-change')
                    } else if (!this.pos) {
                        // IE 2026 09 12 / ODOO-…: окно не двигали — позиция по умолчанию зависит от размера окна, после построения таблицы
                        // пересчитать (снаружи графика: сверху / справа) и перевести привязку
                        this._defPos = null   // {M}: пересчёт положения по умолчанию — здесь, по построенной таблице
                        this.$forceUpdate()
                        this.$nextTick(() => this.$emit('geometry-change'))
                    }
                })
            }
            const dateOf = (i) => {
                const d = (this.rows || [])[i]?.date
                return d ? String(d).slice(0, 7) : ''
            }
            // компактно (ММ.ГГ), длинный диапазон не влезал в заголовок колонки
            const mmyy = (i) => {
                const d = dateOf(i)
                return d ? `${d.slice(5, 7)}.${d.slice(2, 4)}` : ''
            }
            const vi = this.valueIndex()   // IE 2026 09 13 / ODOO-5800: текст заголовка (оформление — gridFormatItem)
            grid.columns[1].header = vi != null ? (this.dateText(vi) || dateOf(vi) || this.t('Period')) : this.t('Period')   // IE 2026 09 12 / ODOO-5800; // IE 2026 09 23 / ODOO-341407: i18n
            grid.columns[1].visible = this.valueColumn   // IE 2026 09 15
            grid.columns[2].visible = !!range && this.valueColumn
            if (range) grid.columns[2].header = `Σ ${mmyy(range.i1)}–${mmyy(range.i2)}`
            // IE 2026 09 15 (заказ Игоря): колонки сравнения — пока точка зафиксирована (ширина окна не прыгает при наведении)
            const hc = this.hoverColumnsOn(), hi = this.hoverCompareIndex()
            for (const i of [3, 4, 5]) if (grid.columns[i]) grid.columns[i].visible = hc
            if (grid.columns[3]) grid.columns[3].header = hi != null ? (this.dateText(hi) || dateOf(hi) || this.t('Point')) : this.t('Point')   // IE 2026 09 23 / ODOO-341407: i18n
        },
    },
}
</script>

<style>
/* стили окна легенды: перенесены из AttrChart 1:1 (ODOO-4646, вынос компонента) */
.chart-legend-panel {
    user-select: none;
    position: absolute;
    z-index: 20;
    display: flex;
    flex-direction: column;
    min-width: 150px;
    max-width: 45%;
    max-height: calc(100% - 70px);
    background: white;
    border: 1px solid #d0d7de;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .15);
    font-size: 12px;
}
.chart-legend-panel-popup {
    max-width: 60%;
    box-shadow: 0 6px 24px rgba(0, 0, 0, .3);
}
/* ODOO-4206: положение своей панели следует кнопкам «Legend position» —
   иначе они видимы, но ни на что не влияют (штатная легенда в этом режиме выключена) */
.chart-legend-pos-right  { top: 30px; right: 6px; left: auto; bottom: auto; }
.chart-legend-pos-left   { top: 30px; left: 6px; right: auto; bottom: auto; }
.chart-legend-pos-top    { top: 30px; left: 50%; right: auto; bottom: auto; transform: translateX(-50%); }
.chart-legend-pos-bottom { bottom: 10px; left: 50%; right: auto; top: auto; transform: translateX(-50%); max-height: 45%; }
.chart-legend-pos-top.chart-legend-panel-popup,
.chart-legend-pos-bottom.chart-legend-panel-popup { max-width: 70%; }
/* ODOO-4440: легенда-расшифровка */
.chart-legend-panel-popup .chart-legend-head { cursor: grab; }
/* IE 2026 09 29 / ODOO-343341 (заказ Игоря: вкладка расшифровки в окне легенды): окно с вкладками [Breakdown | Legend] — AttrTabPanel в теле окна (вид вкладок — как у вкладок приложения);
   полоса вкладок в окне не липкая, расшифровка — своя прокрутка по высоте (как таблица легенды), по ширине — не шире окна */
.chart-legend-tabbed .attr-tab-panel { width: auto; min-width: 0; min-height: 0; }
.chart-legend-tabbed .wj-tabpanel > div > .wj-tabheaders { position: static; padding: 0 6px; border-bottom: 1px solid #eef0f3; }
.chart-legend-tabbed .wj-tabpanel > div > .wj-tabpanes { padding-top: 0; }
.chart-legend-drill { box-sizing: border-box; max-width: 100%; max-height: 46vh; overflow-y: auto; overflow-x: hidden; padding: 4px 8px 6px; }
.chart-legend-drill .dropdown-drill { min-width: 0; max-width: none; }
.chart-legend-drill-hint { color: #6b7280; padding: 10px 2px; white-space: normal; line-height: 1.4; }
.chart-legend-tools {
    display: flex;
    gap: 8px;
    color: #8a8494;
    font-weight: 400;
}
.chart-legend-tools .pi { cursor: pointer; }
.chart-legend-tools .pi:hover, .chart-legend-tool-on { color: #6366f1; }
.chart-legend-glyph { display: inline-flex; width: 15px; flex: none; }
/* ODOO-4440: тело легенды — FlexGrid */
.chart-legend-grid {
    flex: 1;
    min-height: 120px;
    max-height: 46vh;
    width: 400px;   /* 520px при видимой колонке «Итого» (refreshHeaders) */
    border: none;
    font-size: 12px;
}
.chart-legend-grid .wj-cell {
    display: flex;
    align-items: center;
    gap: 6px;
    border: none;
    background: transparent;
    padding: 1px 6px;
}
.chart-legend-grid .chart-lg-name { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.chart-legend-grid .chart-lg-group { font-weight: 600; }
.chart-legend-grid .chart-lg-off { opacity: .45; text-decoration: line-through; }
.chart-legend-grid .chart-lg-check { flex: none; cursor: pointer; }
.chart-legend-grid .chart-lg-sel { flex: none; cursor: pointer; color: var(--cs-accent, #647eff); font-size: 13px; }   /* IE 2026 09 15: чекбокс селектора серии */
.chart-legend-grid .chart-lg-sel:hover { filter: brightness(0.85); }
.chart-legend-grid .chart-lg-value {
    margin-left: auto;
    color: #5c5566;
    font-variant-numeric: tabular-nums;
    white-space: nowrap;
}
.chart-legend-grid .wj-cell.chart-lg-hover { background: #eef2ff !important; box-shadow: inset 3px 0 0 #6366f1; font-weight: 600; } /* IE 2026 09 11 / ODOO-5800 */
/* IE 2026 09 16 (замечание Игоря): нижний блок значений узла / итогов выделения — таблица имя | значение фиксированной ширины (= таблица легенды) */
.chart-legend-footer { flex: none; box-sizing: border-box; border-top: 1px solid #e5e7eb; padding: 6px 10px 7px; font-size: 12px; max-height: 40vh; overflow: auto; background: #fafbff; }
.chart-legend-footer-title { font-weight: 600; color: #1f2937; margin-bottom: 3px; min-height: 18px; line-height: 18px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.chart-legend-footer-sub { font-weight: 400; color: #6b7280; }
.chart-legend-footer-row { display: grid; grid-template-columns: minmax(0, 1fr) minmax(64px, auto); column-gap: 10px; align-items: center; line-height: 18px; min-height: 18px; }
.chart-legend-footer-label { color: #6b7280; min-width: 0; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.chart-legend-footer-cell { display: flex; align-items: center; justify-content: flex-end; gap: 5px; min-width: 0; max-width: 55%; margin-left: auto; }
.chart-legend-footer-dot { flex: none; display: inline-block; width: 9px; height: 9px; border-radius: 50%; }
.chart-legend-footer-value { min-width: 0; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; font-weight: 600; color: #1f2937; font-variant-numeric: tabular-nums; text-align: right; }
/* блок меры размера пузырька: заголовок с глифом-кружком, строка меры, пунктирный разделитель перед остальными реквизитами */
.chart-legend-footer-head { font-size: 10.5px; line-height: 16px; letter-spacing: .04em; text-transform: uppercase; color: #6b7280; white-space: nowrap; }
.chart-legend-footer-size .chart-legend-footer-label, .chart-legend-footer-axis .chart-legend-footer-label { color: #374151; font-weight: 600; }
.chart-legend-footer-head + .chart-legend-footer-row + .chart-legend-footer-head { margin-top: 3px; }
/* глифы осей: X — горизонтальная ось со стрелкой вправо, Y — вертикальная со стрелкой вверх */
.chart-legend-footer-axispi { display: inline-block; width: 11px; height: 11px; margin-right: 5px; box-sizing: border-box; vertical-align: -1px; position: relative; }
.chart-legend-footer-axispi-x { border-bottom: 2px solid #6366f1; }
.chart-legend-footer-axispi-x::after { content: ''; position: absolute; right: -1px; bottom: -4px; border: 3px solid transparent; border-left: 5px solid #6366f1; }
.chart-legend-footer-axispi-y { border-left: 2px solid #6366f1; }
.chart-legend-footer-axispi-y::after { content: ''; position: absolute; left: -4px; top: -1px; border: 3px solid transparent; border-bottom: 5px solid #6366f1; }
.chart-legend-footer-sizepi { display: inline-block; width: 10px; height: 10px; margin-right: 5px; border-radius: 50%; border: 2px solid #6366f1; box-sizing: border-box; vertical-align: -1px; }
.chart-legend-footer-sep { border-top: 1px dashed #d1d5db; margin: 4px 0 3px; }
/* IE 2026 09 15 (заказ Игоря): отклонение точки под курсором от выбранной — рост зелёным, падение красным */
.chart-legend-grid .chart-lg-value.chart-lg-pos { color: #2e7d32; }
.chart-legend-grid .chart-lg-value.chart-lg-neg { color: #c62828; }
/* IE 2026 09 12 / ODOO-…: иконки ▲▼⚙ в ячейке значения убраны (порядок — Alt+drag, настройки — клик по имени) */
.chart-legend-grid .chart-lg-name { cursor: pointer; }
.chart-legend-grid .chart-lg-drop-line { position: absolute; left: 6px; right: 6px; height: 2px; background: #6366f1; z-index: 5; pointer-events: none; box-shadow: 0 0 0 1px rgba(99,102,241,.35); }
.chart-lg-drag-ghost { position: fixed; z-index: 100000; pointer-events: none; padding: 2px 8px; border-radius: 4px; background: rgba(99,102,241,.92); color: #fff; font-size: 12px; white-space: nowrap; box-shadow: 0 2px 6px rgba(0,0,0,.25); }
body.chart-lg-dragging, body.chart-lg-dragging * { cursor: grabbing !important; user-select: none; }
.chart-legend-grid .wj-cell:hover .chart-lg-z { color: #b9a9c1; }
.chart-legend-grid .chart-lg-z:hover { color: #6d4059; }
.chart-legend-grid .wj-cell:hover .chart-lg-gear { color: #b9a9c1; }
.chart-legend-grid .chart-lg-gear:hover { color: #6d4059; }
.chart-legend-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 4px 8px;
    border-bottom: 1px solid #eee;
    font-weight: 600;
}
.chart-legend-head .pi-times {
    cursor: pointer;
    font-size: 11px;
}
/* IE 2026 09 14 / ODOO-5800 (замечание Игоря): крестик закрытия — как у легенды карты (attr-geomap-panel-close): тонкий
   красный × без кружка (красный кружок стоял по замечанию 10.09) */
.chart-legend-head .chart-legend-close {
    flex: 0 0 auto;
    color: #c62828;
    font-size: 1rem;
    margin-right: 2px;
}
.chart-legend-head .chart-legend-close:hover { filter: brightness(0.8); }
.chart-legend-count {
    font-weight: 400;
    font-size: 10px;
    color: #888;
    margin-left: 2px;
}
/* IE 2026 09 13 / ODOO-5800 (замечание Игоря): заголовок колонки периода — дата точки; зафиксированная — жирная с крестиком разморозки,
   под курсором — обычным начертанием серым */
.chart-legend-grid .wj-colheaders .wj-cell { overflow: visible; }
.chart-legend-grid .chart-lg-hdr-frozen { font-weight: 700; color: #1f2937; }
.chart-legend-grid .chart-lg-hdr-hover { font-weight: 500; color: #6b7280; }
.chart-legend-grid .chart-lg-hdr-reset { cursor: pointer; font-size: 10px; margin-left: 5px; color: #8a8494; vertical-align: 0; }
.chart-legend-grid .chart-lg-hdr-reset:hover { color: #dc2626; }
</style>
